module.exports = __webpack_public_path__ + "img/like-blue.5c27f57c.svg";